const APIv4UpdateCustomerInfoResponseAdapter = {
  toUpdateCustomerInfoResponse: v4Response => {
    const {
      response_data
    } = v4Response;
    // console.log('RESPONSE DATAAAA', response_data);
    return response_data;
  }
};
export default APIv4UpdateCustomerInfoResponseAdapter;
